import axios, { CancelTokenSource } from 'axios'
import {
  IInboxFilters,
  IInboxPatchModel,
  IMessageRecipient,
} from 'Modules/Communication/shared/models/Inbox'
import { IPatchModel } from 'shared/models/Common'
import { IEmailMessage, SendMessagePatchBody } from 'shared/models/Message'
import { IMoveJunkModel } from '../models/Email'

const BASE_URL = 'inbox2/email/messages'
const JUNK_MAIL_BASE = (clientId: string) => `inbox2/email/${clientId}/junk`

/** Email */

export const getEmail = (messageId: string, source?: CancelTokenSource) =>
  axios.get(`${BASE_URL}/${messageId}`, {
    cancelToken: source?.token,
  })

export const getEmails = (body: IInboxFilters) =>
  axios.post(`${BASE_URL}/query`, body, {
    cancelToken: body.source?.token,
  })

export const getJunkEmail = (clientId: string, messageId: string) =>
  axios.get(`${JUNK_MAIL_BASE(clientId)}/${messageId}`)

export const getJunkEmails = (body: IInboxFilters) =>
  axios.post(
    `${JUNK_MAIL_BASE(body.clientId!)}/query`,
    { searchText: body.searchText },
    {
      cancelToken: body.source?.token,
    }
  )

export const patchEmail = (model: IInboxPatchModel) =>
  axios.patch(`${BASE_URL}`, model)

export const patchEmailById = (id: string, model: IPatchModel[]) =>
  axios.patch(`${BASE_URL}/${id}`, model)

export const createEmail = (clientId: string, message: IEmailMessage | null) =>
  axios.post(`${BASE_URL}`, {
    clientId,
    title: message?.title || '',
    contentHtml: message?.contentHtml || '',
    recipients: [],
  })

export const getEmailReciept = (messageId: string) =>
  axios.get(`${BASE_URL}/${messageId}/receipt`)

export const getEmailStatistics = (clientId: string) =>
  axios.get(`${BASE_URL}/clients/${clientId}/statistics`)

export const getEmailSeenBy = (messageId: string) =>
  axios.get(`${BASE_URL}/${messageId}/readstatus`)

export const getEmailSeenBySummary = (messageId: string) =>
  axios.get(`${BASE_URL}/${messageId}/readstatus/summary`)

export const setEmailToRead = (messageId: string) =>
  axios.put(`${BASE_URL}/${messageId}/isread`)

export const handleJunkEmail = (clientId: string, body: IMoveJunkModel) =>
  axios.put(`${JUNK_MAIL_BASE(clientId!)}`, body)

/**
 * Delete / update / add to- messages
 */
export const deleteMessage = (id: string) => axios.delete(`${BASE_URL}/${id}`)

export const deleteEmailList = (ids: string[]) =>
  axios.delete(`${BASE_URL}`, { data: { messageIds: ids } })

export const updateEmail = (id: string, body: SendMessagePatchBody[]) =>
  axios.patch(`${BASE_URL}/${id}`, body)

export const addEmailAttachments = (id: string, attachments: FormData) =>
  axios.post(`${BASE_URL}/${id}/attachments`, attachments)

export const updateEmailRecipients = (
  id: string,
  body: IPatchModel<IMessageRecipient[]>[]
) => axios.patch(`${BASE_URL}/${id}/recipients`, body)

export const deleteEmailAttachment = (messageId: string, id: string) =>
  axios.delete(`${BASE_URL}/${messageId}/attachments/${id}`)

/**
 * Send messages
 */
export const createReplyDraft = (messageId: string, isReplyAll: boolean) =>
  axios.post(`${BASE_URL}/${messageId}/reply`, { toAll: isReplyAll })

export const createForwardDraft = (messageId: string) =>
  axios.post(`${BASE_URL}/${messageId}/forward`)

export const sendMessage = (messageId: string) =>
  axios.post(`${BASE_URL}/${messageId}/send`)
